export const makeSelectActiveClassroom = (state: AppState) => state.classesReducer.activeClass;

export const makeSelectClassroomActiveLesson = (state: AppState) =>
  state.classesReducer.activeLesson;
export const makeSelectClassroomLessonsList = (state: AppState) =>
  state.classesReducer.classLessonList;

export const makeSelectClassroomTests = (state: AppState) => state.classesReducer.classTests;
export const makeSelectClassroomActiveTest = (state: AppState) => state.classesReducer.activeTest;

export const makeSelectClassroomActiveWorksheet = (state: AppState) =>
  state.classesReducer.activeWorksheet;
export const makeSelectClassroomWorksheetsList = (state: AppState) =>
  state.classesReducer.classWorksheetList;

export const makeSelectClassrooms = (state: AppState) => state.classesReducer.classrooms;
export const makeSelectClassroomStudents = (state: AppState) =>
  state.classesReducer.classroomStudents;
export const makeSelectClassroomStats = (state: AppState) =>
  state.classesReducer.activeClassroomStats;
export const makeSelectClasroomsSimplifiedLoading = (state: AppState) =>
  state.classesReducer.classroomsSimplifiedLoading;
